import type { Prototype } from "../prototype-types";

export const chrisRodriguezPrototypes: Prototype[] = [
  {
    id: "cr-favorites-popover-interaction",
    name: "Favorites popover interaction",
    path: "/cr/favorites-popover-interaction",
    description:
      "Demonstrates an anchored favorites popover on desktop and a responsive drawer on mobile.",
    owner: "Chris Rodriguez",
    createdAt: "2026-08-03",
    lastUpdated: "2026-08-03",
    surfaceArea: "Retailer",
    project: "Saved Products / Favorites",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/42d014dcde22ba1c146172f8d31224675d5efada3ac9c40cd08bd9e194ab1e5e.png",
    creationTool: "cursor",
  },
];
